import createVueApp from '@/common/createApp'

Styxie.Initializers.MlapProjectsSettingsLsaAttribution = {
  index: async(props) => {
    const { default: LsaAttributionSettings } =
      await import('@/vue_widgets/mlap/settings/lsa_attribution/index.vue')
    createVueApp(LsaAttributionSettings, { props })
  }
}
